<template>
  <div class="account">
    <h2 class="text-light">Choose Account</h2>
    <vuestic-simple-select
      v-if="currentUser"
      :options="currentUser.tenantList"
      :optionKey="'name'"
      v-model="account"
      :clearable="false"
      class="accounts-list"
    />
    <div class="d-flex align--center justify--center">
      <button
        type="button"
        class="btn btn-primary btn-sm btn-block"
        @click="selectAccount"
        :disabled="!account"
      >
        Continue
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'account',
  data() {
    return {
      account: null
    }
  },
  computed: {
    ...mapGetters(['isLoading', 'currentUser'])
  },
  watch: {
    currentUser: {
      immediate: true,
      handler(val) {
        if (val) {
          this.account = val.tenantList[0]
          if (val.tenantList.length == 1) {
            this.selectAccount()
          }
        }
      }
    }
  },
  methods: {
    ...mapActions(['fetchCurrentUser']),
    selectAccount() {
      this.$store.commit('setCurrentAccount', this.account)
      this.$router.push({ path: '/dashboard' })
    }
  },
  created() {
    if (!this.currentUser) {
      this.fetchCurrentUser()
    }
  }
}
</script>

<style lang="scss">
.account {
  @include media-breakpoint-down(md) {
    width: 100%;
    padding-right: 2rem;
    padding-left: 2rem;
    .down-container {
      display: none;
    }
  }

  h2 {
    text-align: center;
    margin-top: 0;
    font-weight: bold;
    font-size: 2rem;
  }
  .accounts-list {
    margin: 4rem 0;
  }
  width: 21.375rem;

  .down-container {
    margin-top: 3.125rem;
  }
}
</style>
